/**
 * Private household note from Chip, October 2026.
 *
 * This is family news, not a Place. It stays off Places, Food, Health,
 * and the guest page. Our Rental shows it with the other house notes, and
 * the concierge keeps a household-tier copy so a question can find it.
 * The website end-use question in the same message is intentionally absent.
 */
export const HOUSEHOLD_FAMILY_NOTE = {
  label: 'Family note',
  body: 'It was hard on Steve too. She moved to Chip and Lisa\'s investment property, so she is still under their roof. She got her EMT license and is applying, and working for Steve, while she waits. It has been really nice.',
};

export function householdFamilyNoteMarkdown(): string {
  return `---
id: household-steve-update
title: Family note — Steve
source_kind: household-note
source_label: Chip
source_date: 2026-10-05
tier: household
---

## Family update
${HOUSEHOLD_FAMILY_NOTE.body}
`;
}
